import React from 'react'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withState, lifecycle } from 'recompose'
import { FormattedMessage } from 'react-intl'

import { Helmet } from 'react-helmet'
import { fetchingState } from '../helpers/hocs.js'
import { get, getCount } from '../store/reducers/persons/list.js'

import Categories from './Categories'
import Button from '../components/Button'
import Person from './../components/Person'
import Loader from './../components/OverlayLoader'

const categoryClick = handler => name => {
  handler(name)
}

const MembersPage = ({ items = [], count = 0, fetching = {}, get, setCategory, category, meta }) => {
  let memebers = items.map((item, i) =>
    <Person
      key={i}
      data={item}
      type='member'
      linkPrefix='members'
      position={i}
    />
  )

  return (
    <div className='Members'>
      <div className='Container'>
      <h1 className='Persons__header bottom-space'>
        <FormattedMessage id='members.expert_text' />
      </h1>
        <Helmet>
          <title>{meta.name}</title>
          <meta name='description' content={meta.description} />
          <meta property='og:title' content={meta.name} />
          <meta property='og:image' content={meta.image} />
          <meta property='og:url' content={window.location.href} />
          <meta property='og:description' content={meta.description} />
        </Helmet>
        {/*<Categories type='persons' current={category} onClick={categoryClick(setCategory)} withAll classPrefix='Members' />*/}

        <section className='Members__section'>
          <Loader loading={fetching.list} isOrange>
            <div className='Members__list'>{memebers}</div>
          </Loader>
        </section>

        { (count > items.length) && (
          <div className='Members__more'>
            <Button onClick={get.bind(this, { offset: items.length })} loading={fetching.button}>
              <FormattedMessage id='members.more' />
            </Button>
          </div>
        )}
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  ...state.persons.list,
  currentLocale: state.intl.locale
})

const mapDispatchToProps = dispatch => bindActionCreators({ get, getCount }, dispatch)

const mergeProps = (state, { getCount, ...dispatch }, { fetchingWrap, ...props }) => ({
  ...props,
  ...state,
  get: (params = {}) => fetchingWrap(dispatch.get.bind(this, params), 'button'),
  init: (params = {}, noLoader = false) => {
    getCount(params)
    return noLoader ? dispatch.get(params) : fetchingWrap(dispatch.get.bind(this, params), 'list')
  }
})

export default compose(
  fetchingState({ multi: true }),
  withState('category', 'setCategory', null),
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  lifecycle({
    componentWillMount () {
      this.props.init({ categoryId: this.props.category }, true)
    },
    componentWillReceiveProps (np) {
      if (np.category !== this.props.category) this.props.init({ categoryId: np.category })
    }
  })
)(MembersPage)



// WEBPACK FOOTER //
// ./src/containers/Members.jsx